// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoscrollController from "./autoscroll_controller"
application.register("autoscroll", AutoscrollController)

import CheckboxSelectorController from "./checkbox_selector_controller"
application.register("checkbox-selector", CheckboxSelectorController)

import FadeController from "./fade_controller"
application.register("fade", FadeController)

import NestedFormController from "./nested-form_controller"
application.register("nested-form", NestedFormController)

import PopupController from "./popup_controller"
application.register("popup", PopupController)

import ScrollToTopController from "./scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import SetSelectController from "./set_select_controller"
application.register("set-select", SetSelectController)

import SetTreeSelectController from "./set_tree_select_controller"
application.register("set-tree-select", SetTreeSelectController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import MultiselectController from "./multiselect_controller"
application.register("multiselect", MultiselectController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import FormAutoSubmitOnloadController from "./form-auto-submit-onload_controller"
application.register("form-auto-submit-onload", FormAutoSubmitOnloadController)

import TypePreferenceController from "./type_preference_controller"
application.register("type-preference", TypePreferenceController)

import PortfolioSearchController from "./portfolio_search_controller"
application.register("portfolio-search", PortfolioSearchController)

import PortfolioQuickAddController from "./portfolio_quick_add_controller"
application.register("portfolio-quick-add", PortfolioQuickAddController)

import TurboSpinnerController from "./turbo_spinner_controller"
application.register("turbo-spinner", TurboSpinnerController)

import DateRangePickerController from "./date-range-picker_controller"
application.register("date-range-picker", DateRangePickerController)

import DateRangeSearchController from "./date-range-search_controller"
application.register("date-range-search", DateRangeSearchController)

import AutoCompleteArtists from "./auto-complete-artists_controller"
application.register("auto-complete-artists", AutoCompleteArtists)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import TypePreferenceToggleController from "./type-preference-toggle_controller"
application.register("type-preference-toggle", TypePreferenceToggleController)

import TypePreferenceListenerController from "./type-preference-listener_controller"
application.register("type-preference-listener", TypePreferenceListenerController)

import TagInputController from "./tag-input_controller"
application.register("tag-input", TagInputController)

import FinishToggleController from "./finish-toggle_controller"
application.register("finish-toggle", FinishToggleController)

import RowRemoveController from "./row-remove_controller"
application.register("row-remove", RowRemoveController)

import S3UploadController from "./s3-upload_controller"
application.register("s3-upload", S3UploadController)

import FinishSelectController from "./finish_select_controller"
application.register("finish-select", FinishSelectController)

import DeckImageDownloadController from "./deck_image_download_controller"
application.register("deck-image-download", DeckImageDownloadController)

import ArticleScheduleController from "./article-schedule_controller"
application.register("article-schedule", ArticleScheduleController)

import SuperFanDatetimeController from "./super-fan-datetime_controller"
application.register("super-fan-datetime", SuperFanDatetimeController)

import CardsViewController from "./cards_view_controller"
application.register("cards-view", CardsViewController)
